export default {
    dev: true,
    baseUrl: '/',
    version: '1.0',
    get apiPath() {
        return '/api/apartment-and-house-insurance-limonade/'
        //       https://rosbankinsurance.ru/box_property_online/test_pay.php
    },

    path: {
        sendInfo: 'send-info/',
        getCode: 'get-code',
        payReceive: 'get-pay-link',
        confirmCode: 'confirm-code',
        //isTW: '/nextbox/index_pay_api.php?action=isTW',
        getFile: 'get-file'
    }
}
